import { getDefaultView } from '@/utils/viewHelpers';
import { createFileRoute, Navigate, redirect } from '@tanstack/react-router';
import { DocumentHead } from '@/components/core/DocumentHead';
import { checkUserPermissions } from '@/components/Auth/checkUserPermissions';

export const Route = createFileRoute('/$tenantId/_layout/tenant-settings/')({
  component: TenantSettingsRedirect,
  beforeLoad: ({ params }) => {
    const hasPermission = checkUserPermissions({
      permission: 'tenant:viewer',
    });
    if (!hasPermission) {
      throw redirect({ to: '/$tenantId', params });
    }
  },
});

function TenantSettingsRedirect() {
  const { tenantId } = Route.useParams();
  const view = getDefaultView('tenant-settings');

  return (
    <>
      <DocumentHead
        titleKey="page.tenantSettings.information.title"
        descriptionKey="page.tenantSettings.information.description"
        resetOnUnmount={false}
      />
      <Navigate
        to="/$tenantId/tenant-settings/$view"
        params={{ tenantId, view }}
        replace
      />
    </>
  );
}
